import React from 'react'
import NotFound from './NotFound'

export default function ErrorPage({children, status}: any) {
  console.log(status, 'statusstatus')

  return <div>{status ? <NotFound /> : children}</div>
}
